import { render, staticRenderFns } from "./ChatParticipantMessage.vue?vue&type=template&id=57a2e49d&scoped=true"
import script from "./ChatParticipantMessage.vue?vue&type=script&lang=js"
export * from "./ChatParticipantMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatParticipantMessage.vue?vue&type=style&index=0&id=57a2e49d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a2e49d",
  null
  
)

export default component.exports